export default "__VITE_ASSET__e7089730__"